/**
 * BookingNotFound.js
 *
 * Shown for a /fly/<pnr> link that doesn't match any passenger, and for any other unknown page under /fly.
 */

import React from "react";
import { useLocation } from "react-router-dom";
import { PlaneLanding } from "lucide-react";
import HomeButton from "./HomeButton";
import { useNoIndex } from "../helpers/flyPage";

/**
 * @param {String} pnr      -   The PNR from the link
 * @returns {JSX.Element}
 */
const BookingNotFound = ({ pnr }) => (
    <div className="w-full max-w-md mx-auto rounded-[22px] overflow-hidden text-center" style={{ background: "#FBF7EF", boxShadow: "0 10px 30px rgba(27,42,65,0.18)" }}>
        <div className="py-5 text-sm font-bold tracking-[0.24em]" style={{ background: "#1B2A41", color: "#FBF7EF" }}>
            RIGHT BROTHER AIRWAYS
        </div>
        <div className="px-5 py-8 sm:px-8 sm:py-10 flex flex-col items-center gap-4">
            <PlaneLanding size={40} color="#C8442F" aria-hidden="true" />
            <h1 className="text-2xl font-bold tracking-[0.12em]">BOOKING NOT FOUND</h1>
            <p className="text-sm" style={{ color: "#5B6577" }}>
                {pnr ? (
                    <>
                        We couldn't find booking{" "}
                        <span className="font-bold break-all" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{pnr}</span>{" "}
                        on Flight YJ030.
                    </>
                ) : "We couldn't find that booking on Flight YJ030."}{" "}
                Please check the link on your invite.
            </p>
            <div className="mt-2"><HomeButton /></div>
        </div>
    </div>
);

/**
 * A whole page for unknown links under /fly, e.g. /fly/hello/there
 */
export const FlyNotFoundPage = () => {
    const { pathname } = useLocation();
    useNoIndex();
    const rest = decodeURIComponent(pathname.replace(/^\/fly\/?/, "")).slice(0, 40);
    return (
        <div className="min-h-screen w-full px-2 sm:px-4 pt-16" style={{ background: "#E9E4DA", color: "#1B2A41", fontFamily: "'Space Grotesk', system-ui, sans-serif" }}>
            <BookingNotFound pnr={rest} />
        </div>
    );
};

export default BookingNotFound;
